import React, { useEffect, useState } from "react";
import Carousel from "@teladoc/nuka-carousel";
import fieldPropTypes from "./field-prop-types";
import FieldBuilder from "./fields-builder";
import CarouselControls from "../theme/default/carouselControls";
import {
  SCREEN_SIZE_BREAKPOINTS,
  DFD_CAROUSEL_SLIDE_WIDTH
} from "../../src/utils/constants";

const ContainerCarousel = ({ field, appData, components, screen }) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [slidesToDisplay, setSlidesToDisplay] = useState(
    window.innerWidth > SCREEN_SIZE_BREAKPOINTS.sm &&
      window.innerWidth < SCREEN_SIZE_BREAKPOINTS.md
      ? 2
      : 1
  );
  const [isSmallScreen, setIsSmallScreen] = useState(
    window.innerWidth > SCREEN_SIZE_BREAKPOINTS.xs &&
      window.innerWidth < SCREEN_SIZE_BREAKPOINTS.sm
  );
  const isChronicCareCarousel = field.name === "chronicCareCarousel";

  const isDFDCarousel = field.params?.includes("TDFieldOptionDFDCarousel");

  useEffect(() => {
    /*
      Removes parsing error that is added by third-party application nuka-carousel:
      "Element <style> not allowed as child element of <div> in this context."
    */
    // document.getElementsByClassName('decorators-wrapper')[0].nextSibling.remove();
  }, []);

  function handleWindowSizeChange() {
    setSlidesToDisplay(
      window.innerWidth > SCREEN_SIZE_BREAKPOINTS.sm &&
        window.innerWidth < SCREEN_SIZE_BREAKPOINTS.md
        ? 2
        : 1
    );
    setIsSmallScreen(
      window.innerWidth > SCREEN_SIZE_BREAKPOINTS.xs &&
        window.innerWidth <= SCREEN_SIZE_BREAKPOINTS.sm
    );
  }

  useEffect(
    () => {
      if (isDFDCarousel) {
        window.addEventListener("resize", handleWindowSizeChange);
      }

      return () => {
        if (isDFDCarousel) {
          window.removeEventListener("resize", handleWindowSizeChange);
        }
      };
    },
    [] /* do not add anything in the array, as it is intensionally kept empty */
  );

  const carouselItemsLength = field.fieldLayouts.length;

  const carouselCounterLabel = `${slideIndex + 1} of ${carouselItemsLength}`;

  const isFirstCarouselItem = () => slideIndex === 0;

  const isLastCarouselItem = () => slideIndex + 1 === carouselItemsLength;

  const toggleNext = () =>
    !isLastCarouselItem() && setSlideIndex(slideIndex + 1);

  const togglePrev = () =>
    !isFirstCarouselItem() && setSlideIndex(slideIndex - 1);

  const nestedContent = field.fieldLayouts.map(page => {
    const isDateLink = page.containerFields.some(
      pageField => pageField.name === "date_label" && pageField.action
    );
    const pageLayoutId = isChronicCareCarousel
      ? page["layout-id"]
      : page.layoutId;

    const WrappingTag = isChronicCareCarousel
      ? "div"
      : carouselItemsLength > 1
      ? "div"
      : "li";

    return (
      <WrappingTag
        key={pageLayoutId}
        className={`page ${pageLayoutId}${
          !isDateLink ? " date-string-container" : ""
        }`}
      >
        {page.containerFields.map(f => (
          <FieldBuilder
            appData={appData}
            components={components}
            field={f}
            key={`field_${f.name}`}
            screen={screen}
          />
        ))}
      </WrappingTag>
    );
  });

  const buttonPrevClassName = `
    ${isFirstCarouselItem() ? "disabled" : ""}
    buttonPrev
  `;

  const buttonNextClassName = `
    ${isLastCarouselItem() ? "disabled" : ""}
    buttonNext
  `;

  const nextButtonAria = getAria("next_button");

  const previousButtonAria = getAria("previous_button");

  function getAria(button) {
    if (!field?.data?.[button]) {
      return "";
    }
    return field.data[button];
  }

  const carouselControls = () => (
    <CarouselControls
      buttonPrevClassName={buttonPrevClassName}
      togglePrev={togglePrev}
      controlsAriaPrevious={previousButtonAria}
      buttonNextClassName={buttonNextClassName}
      toggleNext={toggleNext}
      controlsAriaNext={nextButtonAria}
      carouselCounterLabel={carouselCounterLabel}
    />
  );

  if (field.fieldLayouts.length) {
    return (
      <div
        className={`containerCarousel ${field.name} ${
          field.params ? field.params.split("|").join(" ") : ""
        }`}
      >
        <div className='carouselWrapper'>
          <Carousel
            afterSlide={i => setSlideIndex(i)}
            cellSpacing={1}
            decorators={[]}
            slideIndex={slideIndex}
            heightMode='first'
            slidesToShow={isDFDCarousel ? slidesToDisplay : 1}
            slideWidth={
              isDFDCarousel && isSmallScreen ? DFD_CAROUSEL_SLIDE_WIDTH : 1
            }
          >
            {nestedContent}
          </Carousel>
        </div>
        {carouselItemsLength > 1 && carouselControls()}
      </div>
    );
  }

  return null;
};

ContainerCarousel.propTypes = fieldPropTypes;

export default ContainerCarousel;
